import { createContext, PropsWithChildren, ReactElement, useState } from 'react'

import {
    ConfirmPaymentDataResponse,
    InstalmentOptionsResponse,
    PaymentDetailsDataResponse,
    PaymentOptionsDataResponse,
} from 'pages/Payment/api'
import {
    PaymentReviewDataResponse,
    SamsungPaymentOptionsResponse,
} from 'pages/SamsungPayment/api'
import {
    linkingValidateDataResponse,
    userConsentDataResponse,
} from 'pages/Linking/api'
import { ChallengeData } from 'pages/Payment/ProviderChallenge/api'
import { PaymentInstruction } from 'types/payment'
import { TselWalletDataResponse } from 'pages/TelkomselWallet/api'
import {
    userCreationAcceptConsentDataResponse,
    userCreationDataResponse,
} from 'pages/UserCreation/api'
const initialStore: StoreInterface = {}

export interface StoreInterface {
    // --- Response data
    paymentDetails?: PaymentDetailsDataResponse
    confirmPayment?: ConfirmPaymentDataResponse
    paymentOptions?: PaymentOptionsDataResponse
    installmentOptions?: InstalmentOptionsResponse
    challengeData?: ChallengeData

    paymentReviewData?: PaymentReviewDataResponse
    samsungPaymentOptions?: SamsungPaymentOptionsResponse

    linkingData?: linkingValidateDataResponse
    userOtpData?: userConsentDataResponse

    userCreationData?: userCreationDataResponse
    userCreationOtpData?: userCreationAcceptConsentDataResponse

    tselWalletData?: TselWalletDataResponse
    tselAccessToken?: string
    requestId?: string

    // --- App state data
    selectedPaymentInstructions?: PaymentInstruction[]
    userId?: number
}

export interface StoreContextType {
    store: StoreInterface
    updateStore: (updates: Partial<StoreInterface>) => void
}

export const StoreContext = createContext<StoreContextType>({
    store: initialStore,
    updateStore: () => null,
})

export const StoreProvider = ({
    children,
}: PropsWithChildren<{}>): ReactElement => {
    const [store, setStore] = useState(initialStore)

    const updateStore = (data: Partial<StoreInterface>): void => {
        setStore({ ...store, ...data })
    }

    return (
        <StoreContext.Provider value={{ store, updateStore }}>
            {children}
        </StoreContext.Provider>
    )
}

export default StoreProvider
